import { render, staticRenderFns } from "./briefing_reports_table.vue?vue&type=template&id=f6c7e140"
import script from "./briefing_reports_table.vue?vue&type=script&lang=js"
export * from "./briefing_reports_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports